import { useTransition } from 'react';
import { useRouter } from 'next/navigation';

export default function useRouterTransition() {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const push = (href, options) => {
    startTransition(() => {
      router.push(href, { scroll: false, ...options });
    });
  };

  const prefetch = href => {
    router.prefetch(href);
  };

  return {
    isPending,
    push,
    prefetch
  };
}
